<div class="form-control mb-4">
  <nz-skeleton [nzLoading]="loading" [nzActive]="true">
    <div class="flex justify-between items-center">
      <div class="flex justify-start p-2">
        <strong>Account {{ item.id }}</strong>
      </div>
    </div>
    <hr />
    <div class="flex flex-col gap-2 p-2">
      <div class="flex items-center">
        <div style="width: 200px">
          <span style="font-size: 14px">Bank Name</span>
          <span class="text-red-500" *ngIf="item.isDisable === false">*</span>
        </div>
        <div class="w-full relative">
          <input
            id="typeahead-template"
            type="search"
            class="form-control bank-name"
            style="padding-right: 35px"
            [ngModel]="editPayload.bank_name"
            [ngbTypeahead]="search"
            #inputValue
            [inputFormatter]="formatter"
            [resultFormatter]="formatter"
            [selectOnExact]="true"
            [placeholder]="item.bank_name"
            [disabled]="item.isDisable"
            required
            (ngModelChange)="onEditBankName($event)"
          />
          <svg
            *ngIf="!item.isDisable"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16"
            style="
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              pointer-events: none;
              color: #6c757d;
            "
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
          <small class="text-red-500" *ngIf="item.isEmptyBank">
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              alt=""
              width="12px"
            />
            Bank Cannot Be Empty</small
          >
        </div>
      </div>
      <div class="flex items-center">
        <div style="width: 200px">
          <span style="font-size: 14px">Account Number</span>
          <span class="text-red-500" *ngIf="item.isDisable === false">*</span>
        </div>
        <div class="w-full">
          <input
            type="text"
            class="form-control"
            [ngModel]="editPayload.bank_number"
            [disabled]="item.isDisable"
            (ngModelChange)="onEditBankNumber($event)"
            numberOnly
          />
          <small class="text-red-500" *ngIf="item.isEmptyRek">
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              alt=""
              width="12px"
            />
            Account Cannot Be Empty</small
          >
        </div>
      </div>
      <div class="flex items-center">
        <div style="width: 200px">
          <span style="font-size: 14px">Name</span>
          <span class="text-red-500" *ngIf="item.isDisable === false">*</span>
        </div>
        <div class="w-full">
          <input
            type="text"
            class="form-control"
            [ngModel]="editPayload.bank_owner"
            [disabled]="item.isDisable"
            (ngModelChange)="onEditBankOwner($event)"
          />
          <small class="text-red-500" *ngIf="item.isEmptyOwn">
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              alt=""
              width="12px"
            />
            Account Cannot Be Empty</small
          >
        </div>
      </div>
    </div>
  </nz-skeleton>
</div>
